// 合約管理服務
import { db } from '../cloudsql';

export interface Contract {
  id: string;
  customer_id: string;
  title: string;
  contract_number?: string;
  contract_price?: number;
  start_date?: string;
  end_date?: string;
  contract_file_link?: string;
  payment_method?: string;
  monthly_payment_type?: string;
  prepaid_percentage?: number;
  created_at: string;
  updated_at: string;
}

export interface ContractServiceItem {
  id: string;
  contract_id: string;
  service_type: string;
  contract_price: number;
  unit?: string;
  name?: string;
  quantity?: number;
  created_at: string;
  updated_at: string;
}

export class ContractsService {
  // 取得所有合約
  async getAll(orderBy?: { field: string; direction: 'asc' | 'desc' }[]): Promise<Contract[]> {
    return db.query<Contract>('contracts', {
      orderBy: orderBy || [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 依客戶 ID 取得合約
  async getByCustomerId(customerId: string): Promise<Contract[]> {
    return db.query<Contract>('contracts', {
      where: { customer_id: customerId },
      orderBy: [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 依 ID 取得合約
  async getById(id: string): Promise<Contract | null> {
    return db.getById<Contract>('contracts', id);
  }

  // 建立合約
  async create(data: Omit<Contract, 'id' | 'created_at' | 'updated_at'>): Promise<Contract> {
    return db.create<Contract>('contracts', data);
  }

  // 更新合約
  async update(id: string, data: Partial<Contract>): Promise<Contract> {
    return db.update<Contract>('contracts', id, data);
  }

  // 刪除合約
  async delete(id: string): Promise<void> {
    return db.delete('contracts', id);
  }

  // 合約服務項目相關方法
  async getServiceItems(contractId: string): Promise<ContractServiceItem[]> {
    return db.query<ContractServiceItem>('contract_service_items', {
      where: { contract_id: contractId },
      orderBy: [{ field: 'service_type', direction: 'asc' }]
    });
  }

  async createServiceItem(data: Omit<ContractServiceItem, 'id' | 'created_at' | 'updated_at'>): Promise<ContractServiceItem> {
    return db.create<ContractServiceItem>('contract_service_items', data);
  }

  async updateServiceItem(id: string, data: Partial<ContractServiceItem>): Promise<ContractServiceItem> {
    return db.update<ContractServiceItem>('contract_service_items', id, data);
  }

  async deleteServiceItem(id: string): Promise<void> {
    return db.delete('contract_service_items', id);
  }
}

// 匯出單例
export const contractsService = new ContractsService();


